import * as React from 'react';
import './Call.css';

import { DragSource, DragSourceSpec, DragSourceConnector, DragSourceMonitor } from 'react-dnd'
import Token, { TokenProps } from './Token'
import * as _ from 'lodash'
import * as Model from '../types/document'
import { Cursor } from 'src/lib/Cursor';
import { NodeDrag } from 'src/view/drags';
import { FixDnd } from 'src/view/DragAndDrop';
import { HoveredNodeConsumer } from 'src/view/HoveredNodeContext';
import { clog } from 'src/util';
import { Stack } from 'src/types/stack';


interface NodeTokenProps extends TokenProps {
  nodeId: string,
  blockC: Cursor<Model.Block>,
  stack: Stack,
}

const dragSpec: DragSourceSpec<NodeTokenProps, NodeDrag> = {
  beginDrag(props) {
    const {nodeId, blockC, stack} = props
    return {type: 'copy-reference', nodeId, blockC, stack}
  }
}

function dragCollect(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}

class NodeToken extends React.Component<NodeTokenProps & ReturnType<typeof dragCollect>> {
  render() {
    const { connectDragSource, nodeId, stack, ...otherProps } = this.props
    return <HoveredNodeConsumer>
      {(hoveredNode) => connectDragSource(<span>
        <Token {...otherProps} nodeId={nodeId} stack={stack}/>
      </span>)}
    </HoveredNodeConsumer>
  }
}

export default FixDnd(DragSource("node", dragSpec, dragCollect, {arePropsEqual: () => false})(NodeToken))



// WEBPACK FOOTER //
// ./src/view/NodeToken.tsx